var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.39,
    height: 13.39,
    viewBox: "0 0 13.39 13.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-circle-fill",
    d: "M6.695,13.39A6.695,6.695,0,1,0,0,6.695,6.695,6.695,0,0,0,6.695,13.39Zm.778-7.877L6.636,9.451c-.059.285.024.446.254.446a.926.926,0,0,0,.574-.206l-.074.348a1.733,1.733,0,0,1-1.226.5c-.588,0-.839-.353-.676-1.1l.618-2.9c.054-.245.005-.334-.24-.393l-.377-.068.069-.319,1.916-.24ZM6.695,4.6a.837.837,0,1,1,.837-.837A.837.837,0,0,1,6.695,4.6Z",
    fill: "#13a438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a8347a38ae539c32d3229fceafad1be2.svg";
export { ForwardRef as ReactComponent };